import { useEffect, useState } from 'react';

export const MOBILE_BREAKPOINT = 767;

export const isMobileViewport = () =>
  typeof window !== 'undefined' && window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`).matches;

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(() => isMobileViewport());

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);
    const onChange = () => setIsMobile(mq.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return isMobile;
};
